import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { EDashboardStatusListType, IDashboardStatusLists } from '../../../../../../../../../types/rest/IRestDashboard';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { getBoard } from '../../../../../../../../../store/model/selectors/getBoardById';
import { boardSetStatusLists } from '../../../../../../../../../rest/effects/board/boardSetStatusLists';
import { SegmentBoardEvent, segmentTrackAction } from '../../../../../../../../../middlewares/segment';
import {
    SegmentBoardOption,
    SegmentBoardOptionStatusValue
} from '../../../../../../../../../middlewares/segment/trackEntities/boardEvents';
import { getBoardListsByStatus } from '../../../../../../../../../store/model/selectors/getBoardListsByStatus';
import { IList } from '../../../../../../../../../store/model/list/types';
import { getAuthUser } from '../../../../../../../../../store/model/authUser/selectors/getAuthUser';
import { showSnoozeBlocker } from '../../../../../../../base/effects/showSnoozeBlocker';
import { root } from '../../../../../../../../../store/constants';

export const resetOnHoldInWorkLists = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const board = getBoard(state, boardId);
        const { allowStatusMapping } = getAuthUser(state);
        let statusLists: IDashboardStatusLists = {...board.statusLists};
        if (statusLists && statusLists.inWorkId && statusLists.onHoldId) {
            if (
                !allowStatusMapping &&
                root.App.controller.allowCounterSnackbarHelper.isShowSnackbar('allowStatusMapping')
            ) {
               return Promise.resolve(false);
            } else {
                statusLists[EDashboardStatusListType.ON_HOLD] = 0;
                statusLists[EDashboardStatusListType.IN_WORK] = 0;
                dispatch(segmentTrackAction(SegmentBoardEvent.WORKING_ON_HOLD_TOGGLE_CLICKED, {
                    name: SegmentBoardOption.STATUS,
                    value: SegmentBoardOptionStatusValue.OFF}));
                dispatch(boardSetStatusLists(boardId, statusLists)).then(() => {
                    return Promise.resolve(true);
                });
            }
        } else {
            if (allowStatusMapping) {
                const lists: IList[] = getBoardListsByStatus(state, boardId);
                if (lists.length > 0) {
                    statusLists.onHoldId = getDefaultListForOnHoldList(lists, statusLists);
                }
                if (lists.length > 1) {
                    statusLists.inWorkId = getDefaultListForInWorkList(lists, statusLists);
                }
                dispatch(segmentTrackAction(SegmentBoardEvent.WORKING_ON_HOLD_TOGGLE_CLICKED, {
                    name: SegmentBoardOption.STATUS,
                    value: SegmentBoardOptionStatusValue.ON}));
                dispatch(boardSetStatusLists(boardId, statusLists));
            } else {
                dispatch(showSnoozeBlocker({ allow: 'allowStatusMapping' }));
            }
        }
    };
    return action;
};

const getDefaultListForInWorkList = (lists: IList[], statusLists: IDashboardStatusLists) => {
    const list: IList = lists.find((list: IList) => (list.name.toLowerCase() === 'doing' || list.name.toLowerCase()  === 'in progress') || list.name.toLowerCase()  === 'in work');
    if(list && !Object.values(statusLists).includes(list.id)) return list.id;
    for(let i=0; i<lists.length; i++) {
        if (!Object.values(statusLists).includes(lists[i].id)) {
            return lists[i].id;
        }
    }
    return -1
};

const getDefaultListForOnHoldList = (lists: IList[], statusLists: IDashboardStatusLists) => {
    const list: IList = lists.find((list: IList) => (list.name.toLowerCase() === 'to do' || list.name.toLowerCase()  === 'on hold'));
    if(list && !Object.values(statusLists).includes(list.id)) return list.id;
    for(let i=0; i<lists.length; i++) {
        if (!Object.values(statusLists).includes(lists[i].id)) {
            return lists[i].id;
        }
    }
    return -1
};
